module.exports = __webpack_public_path__ + "media/images/admin/icons/tv-9fc05469a54d3fed7c0da17ea5345f2f.svg";